import "@/components/common/section-components/card/text-elements.css";
import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { LegalOnboardingDetail } from "../schema/handler-functions";

interface Props {
  detail: LegalOnboardingDetail | null;
}

export const RequestingUserDetailCard = ({ detail }: Props) => {
  return (
    <Flex
      flexDir="column"
      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      borderRadius="12px"
      paddingBottom="12px"
    >
      <Text
        className="amd-card-title"
        textTransform="uppercase"
        paddingX="24px"
        paddingTop="14px"
        paddingBottom="16px"
      >
        Detalle usuario solicitante
      </Text>
      <Grid templateColumns="1fr 1fr 1fr 1fr">
        <GridItem paddingX="24px" paddingY="10px">
          <Text className="account-title-label">Usuario Mobile:</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="10px">
          <Text className="account-value-label">
            {detail?.datosUsuario?.nombreApellido ?? "-"}
          </Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="10px">
          <Text className="account-title-label">DNI Usuario:</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="10px">
          <Text className="account-value-label">
            {detail?.datosUsuario?.dni ?? "-"}
          </Text>
        </GridItem>

        <GridItem
          paddingX="24px"
          paddingY="10px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-title-label">Mail Usuario Mobile:</Text>
        </GridItem>
        <GridItem
          paddingX="24px"
          paddingY="10px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-value-label">
            {detail?.emailUsuarioMobile ?? "-"}
          </Text>
        </GridItem>
        <GridItem backgroundColor={AppColors.BACKGROUND_SECONDARY} />
        <GridItem backgroundColor={AppColors.BACKGROUND_SECONDARY} />
      </Grid>
    </Flex>
  );
};
